<template>
    <div class="icon-select">
        <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-light btn-sm flex-grow-1 text-start icon-select-trigger" @click="open = !open">
                <template v-if="value"><i :class="value"></i> <span class="ms-1">{{ iconName }}</span></template>
                <template v-else>Select icon</template>
            </button>
            <button v-if="value" type="button" class="btn btn-sm btn-outline-secondary" title="Remove icon" @click="clear"><i class="fas fa-times"></i></button>
        </div>
        <div v-if="open" class="icon-select-dropdown mt-2 p-2">
            <div class="d-flex gap-2 mb-2">
                <select class="form-select form-select-sm" style="width: 110px" v-model="faStyle">
                    <option value="solid">Solid</option>
                    <option value="regular">Regular</option>
                    <option value="brands">Brands</option>
                </select>
                <input type="text" class="form-control form-control-sm" placeholder="Search icons..." v-model="search" />
            </div>
            <div v-if="!faIcons" class="text-muted small">Loading icons…</div>
            <div v-else class="icon-grid">
                <button v-for="item in filtered" :key="item.cls" type="button" class="icon-grid-btn" :class="{ active: value === item.cls }" :title="item.name" @click="select(item.cls)">
                    <i :class="item.cls"></i>
                </button>
            </div>
            <div v-if="faIcons && capped" class="text-muted small mt-1">Showing first {{ LIMIT }} — refine your search.</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IconSelect",
    props: {
        value: { type: String, default: "" },
    },
    data() {
        return { faIcons: null, faStyle: "solid", search: "", open: false, LIMIT: 300 };
    },
    created() {
        if (this.value && this.value.indexOf("fa-regular") !== -1) this.faStyle = "regular";
        else if (this.value && this.value.indexOf("fa-brands") !== -1) this.faStyle = "brands";
        import("@/components/page-builder/fa7-icons.json").then((m) => {
            this.faIcons = m.default || m;
        });
    },
    computed: {
        iconName() {
            if (!this.value) return "";
            const m = this.value.match(/fa-([a-z0-9-]+)\s*$/i);
            return m ? m[1] : this.value;
        },
        allMatches() {
            if (!this.faIcons) return [];
            const list = this.faIcons[this.faStyle] || [];
            const q = this.search.trim().toLowerCase();
            const out = [];
            for (const entry of list) {
                const name = entry[0];
                if (q) {
                    const hay = (name + " " + (entry[1] || "") + " " + (entry[2] || "")).toLowerCase();
                    if (hay.indexOf(q) === -1) continue;
                }
                out.push({ name, cls: `fa-${this.faStyle} fa-${name}` });
            }
            return out;
        },
        filtered() {
            return this.allMatches.slice(0, this.LIMIT);
        },
        capped() {
            return this.allMatches.length > this.LIMIT;
        },
    },
    methods: {
        select(cls) {
            this.$emit("change", cls);
            this.open = false;
        },
        clear() {
            this.$emit("change", "");
        },
    },
};
</script>

<style scoped>
.icon-select-dropdown {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
}
.icon-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(34px, 1fr));
    gap: 4px;
    max-height: 240px;
    overflow-y: auto;
}
.icon-grid-btn {
    border: 1px solid transparent;
    background: #f5f7f9;
    border-radius: 4px;
    height: 34px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.icon-grid-btn:hover {
    background: #e7ebef;
}
.icon-grid-btn.active {
    border-color: #0d6efd;
    background: #e7f1ff;
}
</style>
